import {Button, ButtonGroup, closeCurrentDialog} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {useReActivateUserMutation} from '@dms/api/customer';
import {ReActivateUserRequestBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {handleApiError} from '../../utils/handleApiError';

export interface ReactivateUserModalProps {
  reactivateUserRequestBody: ReActivateUserRequestBody;
  onSuccess?: () => void;
}

export function ReactivateUserModalContent(props: ReactivateUserModalProps) {
  const [reActivateUser, {isLoading}] = useReActivateUserMutation();

  const handleConfirm = () => {
    reActivateUser({reActivateUserRequestBody: props.reactivateUserRequestBody})
      .unwrap()
      .then(() => {
        closeCurrentDialog();
        props.onSuccess?.();
      })
      .catch(handleApiError);
  };

  return (
    <VStack spacing={4}>
      <Text>{i18n.t('entity.reActivateDialog.description')}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={closeCurrentDialog}
          isDisabled={isLoading}
          title={i18n.t('general.actions.discard')}
        />
        <Button
          variant="primary"
          onClick={handleConfirm}
          isLoading={isLoading}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </VStack>
  );
}
